export default "/images/loading.gif?7d6cfe6558a2cec2d4e4ef8fad4c76ef";